import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'apparel_brand-retailer_pdp_with_mixed_shipping-view';

/**
 * When retailer visits product page and that product has mixed shipping (like combination of ATS and Preorder options) we want to submit an event so we know how many of these products are being viewed
 */
export function trackApparelBrandRetailerPdpWithMixedShippingView(
  retailerToken: string,
  productToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { retailerToken, productToken },
  });
}
